import React from 'react';
import { ShieldCheck, HeartHandshake, Eye, FileCheck, Layers, HeadphonesIcon as Hp, Zap, Sparkles } from 'lucide-react';

const items = [
  { icon: HeartHandshake, title: 'End-to-End Support', desc: 'From first call to certificate delivery — one team owns your case.' },
  { icon: ShieldCheck, title: 'Experienced Team', desc: 'CAs, CS and industry experts with deep filing experience.' },
  { icon: Eye, title: 'Transparent Process', desc: 'Written quote, clear timelines and no hidden fees.' },
  { icon: FileCheck, title: 'Document Guidance', desc: 'Simple checklists, prompt reminders and template drafts.' },
  { icon: Layers, title: 'Multiple Business Services', desc: 'One trusted partner across setup, tax, licensing and growth.' },
  { icon: Zap, title: 'Fast Turnaround', desc: 'Streamlined workflow keeps government timelines predictable.' },
];

export const WhyChooseUs = () => (
  <section className="py-20 bg-gradient-to-b from-white to-[#F6F8FC]" data-testid="why-choose-us">
    <div className="container mx-auto px-4">
      <div className="text-center max-w-3xl mx-auto mb-10">
        <span className="inline-flex items-center gap-2 bg-[#FFB703]/10 text-[#B26A00] px-4 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider">
          <Sparkles size={12} /> Why Choose Us
        </span>
        <h2 className="text-3xl md:text-4xl font-black text-[#0A2463] mt-3">Why businesses choose Utkarshudyam</h2>
        <p className="text-gray-500 mt-2 text-sm md:text-base">Six reasons founders and MSMEs trust us with their most important paperwork.</p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 max-w-6xl mx-auto">
        {items.map((it) => {
          const I = it.icon;
          return (
            <div key={it.title} className="group bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-xl hover:-translate-y-0.5 transition-all p-5">
              <div className="w-11 h-11 rounded-xl bg-[#0A2463]/5 text-[#0A2463] flex items-center justify-center group-hover:bg-[#0A2463] group-hover:text-white transition-colors">
                <I size={20} />
              </div>
              <h3 className="text-base font-bold text-[#0A2463] mt-4">{it.title}</h3>
              <p className="text-sm text-gray-600 mt-1.5 leading-relaxed">{it.desc}</p>
            </div>
          );
        })}
      </div>
    </div>
  </section>
);

export default WhyChooseUs;
